import { dashboardModules } from 'helpers/dashboardCommonUtils';

export function handleClaimNowClick ({ showRewardPasswordModal }) {
  showRewardPasswordModal();
}

export const mapRewardStatusToIcon = {
  EXPIRED: 'alert',
};

export const handleRewardTicketClick = null;
export const handleProductClick = null;

export const shouldRefetchRewards = ({ rewards }) => {
  let shouldRefetch = false;
  rewards?.forEach((reward) => {
    if (reward.currentStatus === 'VERIFIED') {
      shouldRefetch = true;
    }
  });
  return shouldRefetch;
};

export const modulesOrder = [
  dashboardModules.PROMO_BANNER,
  dashboardModules.REWARDS,
  dashboardModules.PROMOTIONS,
  dashboardModules.ARTICLES,
];

export default {
  handleClaimNowClick,
  handleRewardTicketClick,
  handleProductClick,
  mapRewardStatusToIcon,
  shouldRefetchRewards,
};
